import { render, staticRenderFns } from "./TopicGrid.vue?vue&type=template&id=15aa8e55&scoped=true"
import script from "./TopicGrid.vue?vue&type=script&lang=ts"
export * from "./TopicGrid.vue?vue&type=script&lang=ts"
import style0 from "./TopicGrid.vue?vue&type=style&index=0&id=15aa8e55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aa8e55",
  null
  
)

export default component.exports